const {PostCodeService} = require("../services");
const {
    message_post_code_not_exist,
    regexPostalCode,
    message_post_code_invalid,
    message_post_code_required_dash,
    message_fullwidth
} = require("../utils/contains");
const {checkFullwidth} = require("../utils/check-fullwidth");

$(document).ready(function () {
    // -------------------------------------------------------------
    // 会員種別変更
    // -------------------------------------------------------------
    // 会員区分によるフォームの切り替え
    const memberClassChange = () => {
        const selectedMemberClass = $('input[name=member_class]:checked').val();
        if (selectedMemberClass == "4") {
            toggleInpurForm($('#member-normal'), true);
            toggleInpurForm($('#member-d'), false);
            toggleInpurForm($('#member-g'), true);
        } else if (selectedMemberClass == "5") {
            toggleInpurForm($('#member-normal'), true);
            toggleInpurForm($('#member-d'), true);
            toggleInpurForm($('#member-g'), false);
        } else {
            toggleInpurForm($('#member-normal'), false);
            toggleInpurForm($('#member-d'), true);
            toggleInpurForm($('#member-g'), true);
        }
    }
    const toggleInpurForm = (ele, isHide) => {
        ele.prop('disabled', isHide);
        (isHide)? ele.hide(): ele.show();
        ele.find('input').prop('disabled', isHide);
        ele.find('select').prop('disabled', isHide);
        ele.find('option').prop('disabled', isHide);
        ele.find('textarea').prop('disabled', isHide);
        if (isHide) {
            ele.find('input').removeClass('current');
            ele.find('select').removeClass('current');
            ele.find('textarea').removeClass('current');
        } else {
            ele.find('input').addClass('current');
            ele.find('select').addClass('current');
            ele.find('textarea').addClass('current');
        }
    }

    $('input[name=member_class]').on('change', function(ele) {
        memberClassChange();
    });

    memberClassChange();

    // -------------------------------------------------------------
    // 海外在住者対応
    // -------------------------------------------------------------
    const setOverseaAddress = () => {
        const isOversea = $('#oversea').prop('checked');
        if (isOversea) {
            $('.japan').hide();
            $('.japan').prop('disabled', true);
        } else {
            $('.japan').show();
            $('.japan').prop('disabled', false);
        }
    }

    $('#oversea').on('change', function(ele) {
        setOverseaAddress();
    });

    setOverseaAddress();

    // -------------------------------------------------------------
    // 郵便番号検索
    // -------------------------------------------------------------
    function appendErrorPostalCode(isShow = true, message = message_post_code_not_exist) {
        $("#postal-code-wrap-error-postal_code").empty();
        if (isShow) {
            $("#postal-code-wrap-error-postal_code").append(
                `<div id="msg-error-postal_code" class="aino-error-form">${message}</div>`
            );
        }
    }

    function appendErrorSendPostalCode(isShow = true, message = message_post_code_not_exist) {
        $("#postal-code-wrap-error-send_postal_code").empty();
        if (isShow) {
            $("#postal-code-wrap-error-send_postal_code").append(
                `<div id="msg-error-send_postal_code" class="aino-error-form">${message}</div>`
            );
        }
    }

    function handleProvinceCityStreet(selected) {
        const first = selected;
        const currentPostalCode = $('input[name=postal_code].current').first();
        const currentStreet = $('input[name=address_street].current').first();
        const currentProvince = $('select[name=address_province].current').first();
        currentProvince.val(String(first.province).trim());
        let str = first.city;
        if (first.street) {
            str += first.street;
        }
        currentStreet.val(str);

        currentPostalCode.blur();
        currentProvince.blur();
        currentStreet.blur();

        $("#errorMessage_address_street").remove();
        $("#errorMessage_address_province").remove();
    }

    function handleSendProvinceCityStreet(selected) {
        const first = selected;
        $("#send_address_province").val(first.province);
        let str = first.city;
        if (first.street) {
            str += first.street;
        }
        $("#send_address_street").val(str);

        $("#send_postal_code").blur();
        $("#send_address_province").blur();
        $("#send_address_street").blur();
        $("#errorMessage_send_address_street").remove();
        $("#errorMessage_send_address_province").remove();
    }

    function resetAddressCityStreet() {
        const currentStreet = $('input[name=address_street].current').first();
        currentStreet.val("");
    }

    function resetSendAddressCityStreet() {
        $("#send_address_street").val("");
    }

    function registerEventPostalCode() {
        $('button.postal_code').on(
            'click',
            function () {
                appendErrorPostalCode(false);
                const currentPostalCode = $('input[name=postal_code].current').first();
                const val = currentPostalCode.val();
                if (!val) return;
                try {
                    checkFullwidth(val)
                } catch (e) {
                    appendErrorPostalCode(true, message_fullwidth);
                    return;
                }
                if (val.search('-') < 0) {
                    appendErrorPostalCode(true, message_post_code_required_dash);
                    return;
                }
                if (!regexPostalCode.test(val)) {
                    appendErrorPostalCode(true, message_post_code_invalid);
                    return;
                }

                PostCodeService.getInfoByCode(val).then(
                    (response) => {
                        if (response && response.length > 0) {
                            showModalChooseAddressCityStreet(response, (list) => callbackShowModalChooseAddressCityStreet(list, callbackSelectedSuccess1));
                        } else {
                            alert("対象となる住所が存在しません");
                            // back to list default
                            resetAddressCityStreet();
                            // show error post_code invalid
                            appendErrorPostalCode();
                        }
                    }
                );
            }
        );
    }

    registerEventPostalCode();

    $('#closeModalChooseAddressCityStreet').on('click', function () {
        $('#ModalChooseAddressCityStreet').modal('toggle');
    })

    function showModalChooseAddressCityStreet(list, callback) {
        $('#ModalChooseAddressCityStreet').modal('toggle');
        $('#message-error-listAddressCityStreet').empty();
        $('#listAddressCityStreet').empty();
        callback(list);
    }

    function callbackShowModalChooseAddressCityStreet(list = [], callbackSelectedSuccess) {
        let html = '';
        list.forEach(ele => {
            html += `<div class="member-type-item form-check mt-2">
                       <input class="form-check-input" type="radio" name="address_city_street" id="address_city_street" value="${ele.id}">
                        <label class="form-check-label" for="address_city_street}">
                            ${ele.province + ele.city + ele.street}
                        </label>
                    </div>`;
        })

        $('#listAddressCityStreet').append(html);
        registerButtonGetAddressCityStreet(list, callbackSelectedSuccess);
        registerEventCheckedRadioAddressCityStreet();
    }

    function registerEventCheckedRadioAddressCityStreet() {
        $(`input[name=address_city_street]`).on(
            "change",
            function () {
                $('#message-error-listAddressCityStreet').empty();
            }
        );
    }

    function callbackSelectedSuccess1(selected) {
        handleProvinceCityStreet(selected);
        updateIsSamePostalCodeIfChecked();
    }

    function callbackSelectedSuccess2(selected) {
        handleSendProvinceCityStreet(selected);
    }

    function registerButtonGetAddressCityStreet(list = [], callback) {
        $("#btnGetAddressCityStreet").on(
            'click',
            function () {
                const val = $('input[name=address_city_street]:checked').val();
                if (!val) {
                    $('#message-error-listAddressCityStreet').text("都道府県を入力してください。");
                    return;
                }

                const find = list.find(ele => ele.id === parseInt(val));
                if (find) {
                    callback(find);
                    $('#ModalChooseAddressCityStreet').modal('toggle');
                }
            });
    }

    function registerEventIsSamePostalCodeInput() {
        $("#btnsend_postal_code").on(
            'click',
            function () {
                appendErrorSendPostalCode(false);
                const val = $("#send_postal_code").val();
                if (!val) return;
                try {
                    checkFullwidth(val)
                } catch (e) {
                    appendErrorSendPostalCode(true, message_fullwidth);
                    return;
                }
                if (val.search('-') < 0) {
                    appendErrorSendPostalCode(true, message_post_code_required_dash);
                    return;
                }
                if (!regexPostalCode.test(val)) {
                    appendErrorSendPostalCode(true, message_post_code_invalid);
                    return;
                }
                PostCodeService.getInfoByCode(val).then(
                    (response) => {
                        if (response && response.length > 0) {
                            showModalChooseAddressCityStreet(response, (list) => callbackShowModalChooseAddressCityStreet(list, callbackSelectedSuccess2));
                        } else {
                            // back to list default
                            resetSendAddressCityStreet();
                            // show error post_code invalid
                            appendErrorSendPostalCode();
                        }
                    }
                );
            }
        );
    }

    registerEventIsSamePostalCodeInput();

    // -------------------------------------------------------------
    // 書類送付先　法人・団体住所と同じ
    // -------------------------------------------------------------
    $('#is_same_send_post_code').on('change', function() {
        updateIsSamePostalCodeIfChecked();
    });
    function updateIsSamePostalCodeIfChecked() {
        if ($('#is_same_send_post_code').is(":checked")) {
            updateSendInformationChecked();
        }
    }

    function updateSendInformationChecked() {
        const currentPostalCode = $('input[name=postal_code].current').first();
        const currentStreet = $('input[name=address_street].current').first();
        const currentBuilding = $('input[name=address_building].current').first();

        const postal_code = currentPostalCode.val();
        const address_province = $('select[name=address_province].current').first().val();
        const address_street = currentStreet.val();
        const address_building = currentBuilding.val();

        $("#send_postal_code").val(postal_code);
        $("#send_address_province").val(address_province);
        $("#send_address_street").val(address_street);
        $("#send_address_building").val(address_building);

        if (postal_code) {
            $("#send_postal_code").blur();
            $(`#errorMessage_send_postal_code`).remove();
        }
        if (address_province) {
            $("#send_address_province").blur();
            $(`#errorMessage_send_address_province`).remove();
        }
        if (address_street) {
            $("#send_address_street").blur();
            $(`#errorMessage_send_address_street`).remove();
        }
    }

});
